import React from 'react'

const PerformancePage = () => <h1>PerformancePage</h1>

export default PerformancePage
